export const programs = [
  {
    "id": "great-work-foundations",
    "slug": {
      "en": "great-work-foundations",
      "es": "fundamentos-de-la-gran-obra",
      "nl": "fundamenten-van-het-grote-werk",
      "pap": "fundamentonan-di-e-gran-obra"
    },
    "title": {
      "en": "Foundations of The Great Work",
      "es": "Fundamentos de la Gran Obra",
      "nl": "Fundamenten van het Grote Werk",
      "pap": "Foundations of The Great Work"
    },
    "subtitle": {
      "en": "A threshold program for entering the Work without collapsing it into information.",
      "es": "Un programa de umbral para entrar en la Obra sin reducirla a mera información.",
      "nl": "Een drempelprogramma om het Werk binnen te gaan zonder het tot informatie te reduceren.",
      "pap": "Un programa di umbral pa drenta e Obra sin redusié na informashon."
    },
    "language": "en",
    "description": {
      "en": "An introductory program that opens the path before the deeper course work.",
      "es": "Un programa introductorio que abre el camino antes del trabajo de curso más profundo.",
      "nl": "Een inleidend programma dat het pad opent vóór het diepere cursuswerk.",
      "pap": "Un programa introduktorio ku ta habri e kaminda promé ku e trabou di kurso mas profundo."
    },
    "canonicalQuestion": {
      "en": "What falsehood must be removed before the Work can begin?",
      "es": "¿Qué falsedad debe eliminarse antes de que la Obra pueda comenzar?",
      "nl": "Welke onwaarheid moet worden weggenomen voordat het Werk kan beginnen?",
      "pap": "Kua falsedat mester wòrdu kitá promé ku e Obra por kuminsá?"
    },
    "transformationPurpose": {
      "en": "Orient the student from curiosity toward right relationship with truth.",
      "es": "Orientar al estudiante de la curiosidad hacia una relación correcta con la verdad.",
      "nl": "De student begeleiden van nieuwsgierigheid naar een juiste verhouding tot de waarheid.",
      "pap": "Guia e studiante for di kuriosidat pa un relashon korekto ku bèrdat."
    },
    "status": "active",
    "image": null,
    "imageAlt": null,
    "seasons": [
      "threshold-season"
    ],
    "relatedCourses": [
      "university-threshold"
    ],
    "relatedArticles": [
      "divine-synthesis",
      "universal-base-directives-the-three-pillars",
      "to-live-is-to-die-to-die-is-to-be-reborn"
    ]
  },
  {
    "id": "legacy-media-archive",
    "slug": {
      "en": "media-archive",
      "es": "archivo-de-medios",
      "nl": "media-archief",
      "pap": "archivo-di-media"
    },
    "title": {
      "en": "Media Archive",
      "es": "Archivo de Medios",
      "nl": "Media-archief",
      "pap": "Archivo di Media"
    },
    "subtitle": {
      "en": "A public archive of video and podcast study material.",
      "es": "Un archivo publico de materiales de estudio en video y podcast.",
      "nl": "Een publiek archief van video- en podcaststudiemateriaal.",
      "pap": "Un archivo publiko di material di estudio di video i podcast."
    },
    "language": "en",
    "description": {
      "en": "Browse media titles, descriptions, images, links, and embeds as study material.",
      "es": "Explora titulos, descripciones, imagenes, enlaces e inserciones multimedia como material de estudio.",
      "nl": "Bekijk mediatitels, beschrijvingen, beelden, links en embeds als studiemateriaal.",
      "pap": "Wak titulonan, deskripshonnan, imahennan, linknan i embeds di media komo material di estudio."
    },
    "canonicalQuestion": {
      "en": "Which transmissions should be studied now and later organized into deeper sequences?",
      "es": "Que transmisiones deben estudiarse ahora y luego organizarse en secuencias mas profundas?",
      "nl": "Welke uitzendingen moeten nu worden bestudeerd en later in diepere reeksen worden geordend?",
      "pap": "Ki transmishonnan mester wordu studia awor i despues ordena den sekuensianan mas profundo?"
    },
    "transformationPurpose": {
      "en": "Keep the archive available for study while deeper sequencing continues.",
      "es": "Mantener el archivo disponible para el estudio mientras continua la secuencia mas profunda.",
      "nl": "Houd het archief beschikbaar voor studie terwijl de diepere ordening doorgaat.",
      "pap": "Tene e archivo disponibel pa estudio mientras e ordenashon mas profundo ta sigui."
    },
    "status": "completed",
    "image": null,
    "imageAlt": null,
    "seasons": [
      "legacy-media-preservation-season"
    ],
    "relatedCourses": [],
    "relatedArticles": []
  }
];
